import React from 'react';
import { usePermissions, useTranslate } from 'react-admin';
import { Box, Button, Chip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { hasPermission } from '../../utils/hasPermission';
import type { LastOctopusSettlement } from './types';

export const LastSettlementRow = ({ settlement, kioskId }: { settlement: LastOctopusSettlement | null; kioskId: string }) => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { permissions } = usePermissions();
  const t = (key: string) => translate(`resources.kiosk-devices.lastSettlement.${key}`);
  const canView = hasPermission(permissions as string[] | null | undefined, 'kiosk-settlements:read:all');
  const at = settlement === null ? null : settlement.outcome === 'ok' ? settlement.settledAt : settlement.recordedAt;
  if (settlement !== null && at === null) throw new Error(`Octopus settlement ${settlement.id} is ok without a settled time`);
  return (
    <Box data-testid="reader-last-settlement" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, py: 0.75, flexWrap: 'wrap' }}>
      <Typography variant="body2" color="text.secondary">{t('label')}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        {settlement === null || at === null ? (
          <Typography variant="body2">{t('none')}</Typography>
        ) : (
          <>
            <Typography variant="body2">{new Date(at).toLocaleString()}</Typography>
            <Chip size="small" color={settlement.outcome === 'ok' ? 'success' : 'error'} label={t(`outcomes.${settlement.outcome}`)} />
          </>
        )}
        {canView && (
          <Button size="small" onClick={() => navigate(`/kiosk-settlements?filter=${encodeURIComponent(JSON.stringify({ kioskId }))}`)}>{t('view')}</Button>
        )}
      </Box>
    </Box>
  );
};
